interface Props { step: number; total: number; hidden?: boolean }
export function Progress({ step, total, hidden }: Props) {
  return <header className={`progress ${hidden ? "progress--hidden" : ""}`} aria-label={`Otázka ${Math.min(step + 1, total)} z ${total}`}>
    <div className="progress__meta"><span>OTÁZKA {Math.min(step + 1, total)} / {total}</span><span>{Math.round((Math.min(step + 1, total) / total) * 100)} %</span></div>
    <div className="progress__track"><div className="progress__fill" style={{ width: `${(Math.min(step + 1, total) / total) * 100}%` }} /><span className="progress__sparkle" aria-hidden="true">✦</span></div>
  </header>;
}
